// extracted by mini-css-extract-plugin
module.exports = {"content":"dateandtime_content__1x2En","center":"dateandtime_center__lpAxG"};